/**
 * HTML 에디터 내용이 비어있거나 공백만 있는지 확인하는 함수
 */
export const isEditorContentEmpty = (htmlContent: string | undefined | null): boolean => {
  if (!htmlContent) return true;

  // HTML 태그 제거 (모든 태그 제거)
  let textContent = htmlContent.replace(/<[^>]*>/g, '');

  // &nbsp; 제거 (모든 형태의 &nbsp; 제거)
  textContent = textContent.replace(/&nbsp;/gi, '');

  // 일반 공백 문자 제거
  textContent = textContent.trim();

  // 빈 문자열이면 true 반환
  return textContent === '';
};
